import { getQuotes, deleteQuote as deleteQuoteApi } from '../services/api';
import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { notifyDataChanged } from '../utils/dataEvents';
import type { CreatorInfo } from '../utils/permissions';
import { entityStoreMessages, removeItemsWhere } from './storeHelpers';

export interface Quote extends CreatorInfo {
  id: string;
  userId: string; // 建立者（權限判斷用）
  title: string;
  customer: {
    id: string;
    name: string;
    archived?: boolean;
  };
  customerId?: string;
  totalAmount: number;
  status: string;
  createdAt: string;
  /** 用這張報價建立的 PM 專案（列表 API 附帶；PM 連不上時為 null） */
  pmProjectId?: string | null;
  items?: Array<{
    serviceName: string;
    quantity: number;
    unitPrice: number;
  }>;
}

const useQuoteStoreBase = createEntityStore<Quote>({
  entityName: 'quote',
  fetchFn: getQuotes,
  deleteFn: deleteQuoteApi,
  toast,
  messages: entityStoreMessages,
});

export { useQuoteStoreBase };

export const useQuoteStore = () => {
  const store = useQuoteStoreBase();

  const confirmDelete = async () => {
    await store.confirmDelete();
    notifyDataChanged('quotes');
  };

  return {
    quotes: store.items,
    pagination: store.pagination,
    error: store.error,
    isPageLoading: store.isPageLoading,
    showDeleteConfirmModal: store.showDeleteConfirmModal,
    isDeleting: store.isDeleting,
    fetchQuotes: store.fetchItems,
    setCurrentPage: store.setCurrentPage,
    handleDelete: store.handleDelete,
    confirmDelete,
    closeDeleteModal: store.closeDeleteModal,
    updateQuote: store.updateItem,
    addQuote: store.addItem,
    replaceQuote: (tempId: string, realQuote: Quote) => store.updateItem(tempId, realQuote),
    removeQuote: (id: string) => removeItemsWhere<Quote>(useQuoteStoreBase, quote => quote.id === id),
  };
};
